import { call } from "../fn";

const unsubscribe = (listeners, listener) => {
	const index = listeners.indexOf(listener);
	if (index < 0) return;
	listeners.splice(index, 1);
};

const subscribe = listeners => listener => {
	listeners.push(listener);
	return () => unsubscribe(listeners, listener);
};

const notify = listeners => (...args) => {
	listeners.forEach(call(...args));
};

const hasListeners = listeners => () => listeners.length > 0;

const subscriptionApi = listeners => ({
	subscribe: subscribe(listeners),
	notify: notify(listeners),
	hasListeners: hasListeners(listeners),
});

/**
 * Creates new lightweight event emitter
 *
 * @type {() => import("./types").ISubscription}
 */
const subscription = () => subscriptionApi([]);

export const PubSub = subscription;
export default subscription;
